export type TimeLeft = {
  min: number;
  sec: number;
};

export const computeTimeLeft = (expiresAtMs: number, nowMs: number): TimeLeft => {
  const secondsLeft = Math.max(0, Math.floor((expiresAtMs - nowMs) / 1000));

  return {
    min: Math.floor(secondsLeft / 60),
    sec: secondsLeft % 60,
  };
};
